<template>
  <div v-title="$route.meta.title" class="assign-review-page">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>任务管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
        <TaskDescButton></TaskDescButton>
      </el-breadcrumb>
    </div>

    <!-- 快捷操作 -->
    <div class="quick-actions">
      <span class="quick-label">将所有实习生抽检比例设置为</span>
      <el-input v-model="quickForm.sampleRate"
                type="number"
                placeholder=""
                class="quick-input quick-input-rate"
                min="0"
                max="100"
                step="1"
                @input="onQuickSampleRateInput">
        <template slot="append">%</template>
      </el-input>
      <el-button type="primary"
                 size="small"
                 @click="applyQuickSettings">应用</el-button>
    </div>

    <!-- 1. 来源分配 & 抽检比例 -->
    <source-allocation-panel ref="sourcePanel"
                             :query-params="$route.query"
                             @total-expected="totalExpected = $event">
    </source-allocation-panel>

    <!-- 2. 分配给复核人 -->
    <reviewer-assign-panel ref="reviewerPanel"
                           :total-expected="totalExpected"
                           :review-target-date="reviewTargetDate">
    </reviewer-assign-panel>

    <!-- 底部操作：置于页面内容流内 -->
    <div class="page-actions">
      <el-button @click="onCancel">取消</el-button>
      <el-button type="primary"
                 :loading="submitting"
                 @click="onConfirmAssign">确认分配</el-button>
    </div>
  </div>
</template>

<script>
import TaskDescButton from '@/views/task/components/buttons/TaskDescButton'
import SourceAllocationPanel from '@/views/order/components/SourceAllocationPanel.vue'
import ReviewerAssignPanel from '@/views/order/components/ReviewerAssignPanel.vue'
import { submitTaskAssignment } from '@/views/order/order.api'

export default {
  name: 'AssignReviewPage',
  components: {
    TaskDescButton,
    SourceAllocationPanel,
    ReviewerAssignPanel
  },
  data () {
    return {
      quickForm: {
        reviewTarget: '',
        sampleRate: ''
      },
      totalExpected: 0,
      reviewTargetDate: '',
      submitting: false
    }
  },
  methods: {
    onQuickSampleRateInput () {
      const raw = String(this.quickForm.sampleRate || '').replace(/\D/g, '').slice(0, 3)
      if (raw === '') {
        this.quickForm.sampleRate = ''
      } else {
        const num = Math.min(100, Math.max(0, parseInt(raw, 10) || 0))
        this.quickForm.sampleRate = String(num)
      }
    },
    applyQuickSettings () {
      const target = this.quickForm.reviewTarget
      const rate = this.quickForm.sampleRate
      if (target !== '') {
        const panel = this.$refs.reviewerPanel
        if (panel && panel.setAssignedCount) {
          panel.setAssignedCount(target)
        }
      }
      if (rate !== '') {
        const panel = this.$refs.sourcePanel
        if (panel && panel.applySampleRate) {
          panel.applySampleRate(rate)
        }
      }
    },
    onCancel () {
      this.$router.go(-1)
    },
    // 组装确认分配请求数据：searchParams(路由参数) + 来源分配(实习生ID,预计) + 复核分配(复核人ID,复核单量)
    getConfirmAssignPayload () {
      const query = this.$route.query || {}
      const searchParams = { ...query }

      const sourcePanel = this.$refs.sourcePanel
      const internList = sourcePanel && sourcePanel.internList ? sourcePanel.internList : []
      const sourceAllocation = internList.map(row => ({
        intern_user_id: row.intern_user_id != null ? row.intern_user_id : row.id,
        expected: Number(row.expected) || 0
      }))

      const reviewerPanel = this.$refs.reviewerPanel
      const reviewerList = reviewerPanel && reviewerPanel.reviewerList ? reviewerPanel.reviewerList : []
      const reviewAssignment = reviewerList.map(row => ({
        reviewer_id: row.id,
        adminname: row.name != null ? String(row.name) : '',
        assigned_count: Number(row.assignedCount) || 0
      }))

      return {
        searchParams,
        source_allocation: sourceAllocation,
        review_assignment: reviewAssignment
      }
    },
    onConfirmAssign () {
      const reviewerPanel = this.$refs.reviewerPanel
      const reviewerList = reviewerPanel ? reviewerPanel.reviewerList : []
      if (reviewerList.length === 0) {
        this.$message.warning('请至少添加一名复核人')
        return
      }
      const totalAssignedCount = reviewerPanel ? reviewerPanel.totalAssignedCount : 0
      if (totalAssignedCount <= 0) {
        this.$message.warning('复核单量必须大于0')
        return
      }
      if (totalAssignedCount > this.totalExpected) {
        this.$message.warning('复核单量总计不能超过预计总计')
        return
      }
      const payload = this.getConfirmAssignPayload()
      this.submitting = true
      submitTaskAssignment(payload)
        .then(() => {
          this.$message.success('分配成功')
          this.$router.go(-1)
        })
        .catch(err => {
          const msg = (err && err.response && err.response.data && err.response.data.message) || (err && err.message) || '分配失败'
          this.$message.error(msg)
        })
        .finally(() => {
          this.submitting = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.assign-review-page {
  padding-bottom: 40px;
}

.page-heading {
  margin-bottom: 16px;
}

.quick-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 16px;
  padding: 12px 16px;
  margin-bottom: 16px;
  background: #fdf6ec;
  border: 1px solid #f5d9b8;
  border-radius: 4px;

  .quick-label {
    color: #606266;
    font-size: 14px;
  }

  .quick-input {
    width: 180px;

    &.quick-input-rate {
      width: 180px;
    }
  }
}

.layout-panel {
  margin-bottom: 16px;
}

.page-actions {
  margin-top: 24px;
  display: flex;
  gap: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/order/pages/AssignReviewPage.vue